import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../ui/FadeIn';
export function ProblemSection() {
  return <section className="bg-white py-24 px-6 border-y border-copper/10" data-id="element-153">
      <div className="max-w-5xl mx-auto" data-id="element-154">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-155">
          <FadeIn data-id="element-156">
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-157">
              Después de los 45 años,{' '}
              <span className="text-copper italic" data-id="element-158">
                las reglas del juego cambian.
              </span>
            </h2>
            <p className="text-lg text-charcoal/80 mb-6 leading-relaxed" data-id="element-159">
              El estrógeno baja, el cortisol sube y tu metabolismo se vuelve
              "lento" para protegerse. Intentar bajar de peso con las dietas de
              tus 20s solo estresa más a tus hormonas, provocando más retención
              de líquidos, sofocos y esa frustrante "niebla mental".
            </p>
            <p className="text-xl font-medium text-charcoal mt-8 border-l-4 border-copper pl-6 py-2" data-id="element-160">
              Necesitas dejar de pelear contra tu biología y empezar a trabajar
              con ella.
            </p>
          </FadeIn>

          <div className="bg-cream p-10 rounded-sm shadow-sm border border-copper/20" data-id="element-161">
            <FadeIn data-id="element-162">
              <h3 className="text-2xl font-serif text-charcoal mb-8 text-center" data-id="element-163">
                Por qué lo que intentaste no funcionó:
              </h3>
            </FadeIn>
            <StaggerContainer className="space-y-6" data-id="element-164">
              <StaggerItem className="flex gap-4 items-start" data-id="element-165">
                <div className="w-6 h-6 rounded-full bg-red-100 text-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-166">
                  ✕
                </div>
                <p className="text-charcoal/80" data-id="element-167">
                  <strong className="text-charcoal" data-id="element-168">
                    Dietas restrictivas:
                  </strong>{' '}
                  Disparan tu hormona del estrés, bloqueando la quema de grasa
                  abdominal.
                </p>
              </StaggerItem>
              <StaggerItem className="flex gap-4 items-start" data-id="element-169">
                <div className="w-6 h-6 rounded-full bg-red-100 text-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-170">
                  ✕
                </div>
                <p className="text-charcoal/80" data-id="element-171">
                  <strong className="text-charcoal" data-id="element-172">
                    Jugos verdes "detox":
                  </strong>{' '}
                  Suelen ser altos en azúcares que inflaman tu intestino
                  sensible.
                </p>
              </StaggerItem>
              <StaggerItem className="flex gap-4 items-start" data-id="element-173">
                <div className="w-6 h-6 rounded-full bg-red-100 text-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-174">
                  ✕
                </div>
                <p className="text-charcoal/80" data-id="element-175">
                  <strong className="text-charcoal" data-id="element-176">Exceso de café:</strong>{' '}
                  Para combatir la fatiga irrita tu sistema digestivo y empeora
                  los sofocos.
                </p>
              </StaggerItem>
              <StaggerItem className="flex gap-4 items-start" data-id="element-177">
                <div className="w-6 h-6 rounded-full bg-red-100 text-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-178">
                  ✕
                </div>
                <p className="text-charcoal/80" data-id="element-179">
                  <strong className="text-charcoal" data-id="element-180">Falta de proteína:</strong>{' '}
                  Ignorar la importancia de una proteína de alta calidad hace
                  que pierdas músculo y firmeza.
                </p>
              </StaggerItem>
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>;
}